// Metadata for product 3D references. This is deliberately separate from
// pricing, availability and order data; the 3D viewer will consume it in
// Micro-sprint 3D.2.
export const PRODUCT_3D_REFERENCES = Object.freeze({
  "PAN-250": Object.freeze({
    productCode: "PAN-250",
    assetStatus: "REFERENCIA_AR_LOCAL",
    format: "GLB_USDZ",
    modelSource: "Titina · activo procedural de demostración",
    sourceUrl: null,
    viewerUrl: null,
    arModelUrl: "/assets/ar/pan-titina-reference.glb",
    iosModelUrl: "/assets/ar/pan-titina-reference.usdz",
    license: "Activo propio de demostración",
    attribution: null,
    arEnabled: true,
    dimensions: "25 × 15 × 12 cm aproximadamente",
    localAssetPath: "/assets/ar/pan-titina-reference.glb",
    note: "Activo 3D local de demostración para validar realidad aumentada. No es todavía un escaneo del pan final de Titina."
  })
});

// P01 is the ERP presentation code for Pan; PAN-250 is the web catalog code.
// Both resolve to the same reference record, not to two product definitions.
const PRODUCT_CODE_ALIASES = Object.freeze({ P01: "PAN-250" });

export function product3dFor(productCode) {
  const code = String(productCode || "").trim();
  return PRODUCT_3D_REFERENCES[code] || PRODUCT_3D_REFERENCES[PRODUCT_CODE_ALIASES[code]] || null;
}
